import { DataNode } from 'antd/lib/tree';
import { Tree } from 'antd';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function MenuTree({ open, callback }: any) {
    const { useLang, useEffect, useState } = useGlobal();
    const { t } = useLang('vanlife');
    const [selectedKeys, setSelectedKeys] = useState([]);
    // const [items, setItems] = useState([]);
    const treeData: DataNode[] = [
        {
            title: t('menu_main1'),
            key: 'vanlife-B',
        },
        {
            title: t('menu_main2'),
            key: 'vanlife-C',
            children: [
                {
                    title: t('menu_main2_sub1'),
                    key: 'vanlife-C-1',
                },
                {
                    title: t('menu_main2_sub2'),
                    key: 'vanlife-C-2',
                },
                {
                    title: t('menu_main2_sub3'),
                    key: 'vanlife-C-3',
                },
                {
                    title: t('menu_main2_sub4'),
                    key: 'vanlife-C-4',
                },
                {
                    title: t('menu_main2_sub5'),
                    key: 'vanlife-C-5',
                },
            ],
        },
        {
            title: t('menu_main3'),
            key: 'vanlife-D',
            children: [
                {
                    title: t('menu_main3_sub1'),
                    key: 'vanlife-D-1',
                },
                {
                    title: t('menu_main3_sub2'),
                    key: 'vanlife-D-2',
                },
                {
                    title: t('menu_main3_sub3'),
                    key: 'vanlife-D-3',
                },
                {
                    title: t('menu_main3_sub4'),
                    key: 'vanlife-D-4',
                },
            ],
        },
        {
            title: t('menu_main4'),
            key: 'vanlife-E',
            children: [
                {
                    title: t('menu_main4_sub1'),
                    key: 'vanlife-E-1',
                },
                {
                    title: t('menu_main4_sub2'),
                    key: 'vanlife-E-2',
                },
                {
                    title: t('menu_main4_sub3'),
                    key: 'vanlife-E-3',
                },
            ],
        },
        {
            title: t('menu_main5'),
            key: 'vanlife-F',
            children: [
                {
                    title: t('menu_main5_sub1'),
                    key: 'vanlife-F-1',
                },
                {
                    title: t('menu_main5_sub2'),
                    key: 'vanlife-F-2',
                },
                {
                    title: t('menu_main5_sub3'),
                    key: 'vanlife-F-3',
                },
                {
                    title: t('menu_main5_sub4'),
                    key: 'vanlife-F-4',
                },
                {
                    title: t('menu_main5_sub5'),
                    key: 'vanlife-F-5',
                },
            ],
        },
        {
            title: t('menu_main6'),
            key: 'vanlife-G',
            children: [
                {
                    title: t('menu_main6_sub1'),
                    key: 'vanlife-G-1',
                },
                {
                    title: t('menu_main6_sub2'),
                    key: 'vanlife-G-2',
                },
                {
                    title: t('menu_main6_sub3'),
                    key: 'vanlife-G-3',
                },
                {
                    title: t('menu_main6_sub4'),
                    key: 'vanlife-G-4',
                },
                {
                    title: t('menu_main6_sub5'),
                    key: 'vanlife-G-5',
                },
            ],
        },
        {
            title: t('menu_main7'),
            key: 'vanlife-H',
            children: [
                {
                    title: t('menu_main7_sub1'),
                    key: 'vanlife-H-1',
                },
                {
                    title: t('menu_main7_sub2'),
                    key: 'vanlife-H-2',
                },
                {
                    title: t('menu_main7_sub3'),
                    key: 'vanlife-H-3',
                },
            ],
        },
        {
            title: t('menu_main8'),
            key: 'vanlife-J',
            children: [
                {
                    title: t('menu_main8_sub1'),
                    key: 'vanlife-J-1',
                },
                {
                    title: t('menu_main8_sub2'),
                    key: 'vanlife-J-2',
                },
                {
                    title: t('menu_main8_sub3'),
                    key: 'vanlife-J-3',
                },
                {
                    title: t('menu_main8_sub4'),
                    key: 'vanlife-J-4',
                },
            ],
        },
        {
            title: t('menu_main9'),
            key: 'vanlife-K',
            children: [
                {
                    title: t('menu_main9_sub1'),
                    key: 'vanlife-K-1',
                },
                {
                    title: t('menu_main9_sub2'),
                    key: 'vanlife-K-2',
                },
                {
                    title: t('menu_main9_sub3'),
                    key: 'vanlife-K-3',
                },
                {
                    title: t('menu_main9_sub4'),
                    key: 'vanlife-K-4',
                },
                {
                    title: t('menu_main9_sub5'),
                    key: 'vanlife-K-5',
                },
            ],
        },
        {
            title: t('menu_main10'),
            key: 'vanlife-L',
            children: [
                {
                    title: t('menu_main10_sub1'),
                    key: 'vanlife-L-power',
                    children: [
                        {
                            title: t('menu_main10_sub1_child1'),
                            key: 'vanlife-L-power-series-river',
                        },
                        {
                            title: t('menu_main10_sub1_child2'),
                            key: 'vanlife-L-power-series-delta',
                        },
                    ],
                },
                {
                    title: t('menu_main10_sub2'),
                    key: 'vanlife-L-smart',
                    children: [
                        {
                            title: t('menu_main10_sub2_child1'),
                            key: 'vanlife-L-smart-series-wave2',
                        },
                    ],
                },
            ],
        },
        {
            title: t('menu_main11'),
            key: 'vanlife-M',
        },
    ];

    const handleClick = (selectedKeys: any, _: any) => {
        setSelectedKeys(selectedKeys);
        const target = document.querySelector(`#${selectedKeys[0]}`) as HTMLElement;
        if (target) {
            window.scrollTo({
                top: target?.offsetTop,
                behavior: 'smooth',
            });
        } else {
            callback(true);
            setTimeout(() => {
                const afterOpenTarget = document.querySelector(`#${selectedKeys[0]}`) as HTMLElement;
                if (afterOpenTarget) {
                    window.scrollTo({
                        top: afterOpenTarget?.offsetTop,
                        behavior: 'smooth',
                    });
                }
            }, 0);
        }
    };

    const handleScroll = (e: any) => {
        e.stopPropagation();
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const winH = window.innerHeight;
            const enterFunc = (id: string) => {
                const target = document.querySelector(`#${id}`) as HTMLElement;
                if (target) {
                    AniContainer.create({
                        triggerElement: target,
                        triggerHook: 1,
                        offset: winH - 80,
                        duration: target?.offsetHeight,
                        onEnter: () => setSelectedKeys([id]),
                    });
                }
            };
            const idsArr: string[] = [
                'vanlife-B',
                'vanlife-C',
                'vanlife-C-1',
                'vanlife-C-2',
                'vanlife-C-3',
                'vanlife-C-4',
                'vanlife-C-5',
                'vanlife-D',
                'vanlife-D-1',
                'vanlife-D-2',
                'vanlife-D-3',
                'vanlife-D-4',
                'vanlife-E',
                'vanlife-E-1',
                'vanlife-E-2',
                'vanlife-E-3',
                'vanlife-F',
                'vanlife-F-1',
                'vanlife-F-2',
                'vanlife-F-3',
                'vanlife-F-4',
                'vanlife-F-5',
                'vanlife-G',
                'vanlife-G-1',
                'vanlife-G-2',
                'vanlife-G-3',
                'vanlife-G-4',
                'vanlife-G-5',
                'vanlife-H',
                'vanlife-H-1',
                'vanlife-H-2',
                'vanlife-H-3',
                'vanlife-J',
                'vanlife-J-1',
                'vanlife-J-2',
                'vanlife-J-3',
                'vanlife-J-4',
                'vanlife-K',
                'vanlife-K-1',
                'vanlife-K-2',
                'vanlife-K-3',
                'vanlife-K-4',
                'vanlife-K-5',
                'vanlife-L',
                'vanlife-L-power',
                'vanlife-L-power-series-river',
                'vanlife-L-power-series-delta',
                'vanlife-L-smart',
                'vanlife-L-smart-series-wave2',
                'vanlife-M',
            ];

            idsArr.map((id: string) => enterFunc(id));
        }
    }, [open]);

    // useEffect(() => {
    //     const arr: any[] = [];
    //     const litera = (data: any[]) => {
    //         if (!Array.isArray(data)) return;
    //         data?.map((item: any) => {
    //             arr.push({ text: item.title, link: `#${item.key}` });
    //             if (item?.children && Array.isArray(item.children) && item?.children.length > 0) {
    //                 litera(item?.children);
    //             }
    //         });
    //     };
    //     litera(treeData);
    //     setItems(arr);
    // }, []);

    return (
        <div id="vanlife-menu-tree" className={`vanlife-menu-tree ${css['vanlife-menu-tree']}`}>
            <div className="sticky-box" onScroll={handleScroll}>
                <Tree treeData={treeData} defaultExpandAll selectable selectedKeys={selectedKeys} onSelect={handleClick} />
            </div>
        </div>
    );
}
